export default {
    Companies: 'الشركة|الشركات',
};
